import i18n from '@/i18n';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { LIST_PROVINCE_BLOCK, OPTION_INPUT_FORMAT, OPTION_INPUT_FORMAT_FULL_NAME, OPTION_AGE_CONDITION } from '../setting-block-form/constants';
import store from '@/state/store';

const listMessagesStore = store.getters['managerForm/listMessageBlocks'];
const getListMsgStore = (type) => listMessagesStore.filter((msgItem) => msgItem.action.includes(type));

const configFormPage = () => {
    return {
        configFieldSelectPage: {
            trackBy: 'id',
            label: 'name',
            errorField: i18n.t('managerForm.settingPage.pageType'),
            valueSync: null,
            error: false,
            isRemove: false,
            isRequired: false,
            typesValidate: ['requiredSelect']
        }
    };
};

const configEditFormPage = () => {
    return {
        configFieldSelectBlockDefault: {
            trackBy: 'id',
            label: 'name',
            errorField: i18n.t('managerForm.settingPage.pageType'),
            valueSync: null,
            error: false,
            isRemove: false,
            isRequired: false,
            typesValidate: []
        },
        configFieldSelectBlock: {
            trackBy: 'id',
            label: 'name',
            errorField: i18n.t('managerForm.settingPage.pageType'),
            valueSync: null,
            error: false,
            isRemove: false,
            isRequired: false,
            typesValidate: []
        },
        title: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.titlePage'),
            errorCustomMess: '',
            valueSync: '',
            typesValidate: ['required', 'max255']
        }
    };
};

const configEditLabelPage = () => {
    return {
        configFieldLabelInputRequired: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.labelButton'),
            errorCustomMess: '',
            valueSync: '',
            length: 20,
            typesValidate: ['required', 'maxCustom']
        },
        configFieldLabelInputConfirm: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.labelButton'),
            errorCustomMess: '',
            valueSync: '',
            length: 20,
            typesValidate: ['required', 'maxCustom']
        }
    };
};
const configEditButtonPage = () => {
    return {
        configFieldButtonInput: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.buttonRegister'),
            errorCustomMess: '',
            valueSync: '',
            length: 30,
            typesValidate: ['required', 'maxCustom']
        },
        configFieldButtonConfirm: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.buttonConfirm'),
            errorCustomMess: '',
            valueSync: '',
            length: 30,
            typesValidate: ['required', 'maxCustom']
        },
        configFieldButtonBack: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.buttonBack'),
            errorCustomMess: '',
            valueSync: '',
            length: 30,
            typesValidate: ['required', 'maxCustom']
        }
    };
};
const configEditButtonPage_I = () => {
    return {
        configFieldButtonInput: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.buttonRegister'),
            errorCustomMess: '',
            valueSync: '',
            length: 30,
            typesValidate: ['required', 'maxCustom']
        },
        configFieldButtonConfirm: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.buttonConfirm'),
            errorCustomMess: '',
            valueSync: '',
            length: 30,
            typesValidate: ['required', 'maxCustom']
        },
        configFieldButtonBack: {
            isNumber: false,
            isMaxLength: false,
            error: false,
            errorField: i18n.t('managerForm.settingPage.buttonBack'),
            errorCustomMess: '',
            valueSync: '',
            length: 30,
            typesValidate: ['required', 'maxCustom']
        }
    };
};

const configFormDraw = () => {
    return {
        extension: {
            automatic_redirect_after: {
                isNumber: true,
                min: 3,
                max: 9999,
                error: false,
                errorField: i18n.t('managerForm.settingPage.pageTypeB.buttonValidTime'),
                typesValidate: ['max10', 'limit-input']
            },
            btn_skip: {
                error: false,
                length: 30,
                errorField: i18n.t('managerForm.settingPage.pageTypeB.skipButton'),
                typesValidate: ['maxCustom']
            }
        }
    };
};
const configFormWinning = () => {
    return {
        extension: {
            text_above: {
                errorField: i18n.t('managerForm.settingPage.pageTypeB.topText'),
                height: 300,
                error: false,
                typesValidate: []
            },
            text_below: {
                errorField: i18n.t('managerForm.settingPage.pageTypeB.bottomText'),
                height: 300,
                error: false,
                typesValidate: []
            }
        }
    };
};

const configFormRejection = () => {
    return {
        extension: {
            text_above: {
                errorField: i18n.t('managerForm.settingPage.pageTypeB.topText'),
                height: 300,
                error: false,
                typesValidate: []
            },
            no_win_content: {
                errorField: i18n.t('managerForm.settingPage.pageTypeB.rejectionDetail'),
                height: 300,
                error: false,
                typesValidate: ['required']
            },
            text_below: {
                errorField: i18n.t('managerForm.settingPage.pageTypeB.bottomText'),
                height: 300,
                error: false,
                typesValidate: []
            }
        }
    };
};

const configModalAddPage = {
    title: 'ページを追加',
    model: false,
    scrollable: true,
    hideFooter: false,
    class: 'h-25',
    size: 'lg',
    validate: true
};

const configModalEditPage = () => {
    return {
        id: '',
        title: 'ページを追加',
        model: false,
        scrollable: true,
        hideFooter: false,
        class: 'h-100',
        size: '4xl',
        validate: true
    };
};
const configModalPreviewForm = {
    id: '',
    title: 'プレビュー ',
    model: false,
    scrollable: true,
    hideFooter: false,
    class: 'h-100',
    size: '4xl',
    validate: false,
    masterPage: []
};

const configModalSendMailed = {
    id: '',
    title: 'プレビューURLを送る',
    model: false,
    scrollable: true,
    hideFooter: false,
    class: 'h-65',
    size: 'lg',
    validate: true,
    masterPage: [],
    titleBtnSave: i18n.t('managerForm.settingPage.btnSendEmail')
};

const initFormBlock = (data = null) => {
    let obj = {
        // start common block
        block_name: '',
        block_type: '',
        order_required: false,
        is_scroll_none: false,
        is_border_display: true,
        custom_height: 300,
        label: '',
        input_field_size: '',
        text_area_more_option: '',
        confirmation_page_display: 1,
        personal_information_setting: false,
        placeholder: '',
        max_characters: '255',
        number_of_items_displayed_per_line: 1,
        choice_placement_specification_question: 'default',
        choice_placement_specification_answer: 'default',
        layout: 'default',
        if_conditions_do_not_match: '',
        default_choice: null,
        default_choices: [],
        value_default_text: '',
        unselected_label: '',
        input_format: null,
        cell_background_color: {
            bg_question: '',
            bg_answer: '',
            is_bg_question_default: true,
            is_bg_answer_default: true
        },
        input_condition: {
            type: 'AND',
            conditions: [],
            status: 1
        },
        additional_setting: {
            note_left_block: '',
            note_right_block: '',
            note_bottom_block: '',
            error_message_block: []
        },
        setting_others: {
            other_use: false,
            label_other: 'その他',
            value_other_required: false,
            width_other: '', //100
            uncheck_use: false,
            label_uncheck: 'チェックを外す'
        },
        option_value: [],
        option_unselected_label: {
            option_index: 0,
            unique_key: null,
            value: '',
            number_of_receptions: null
        },
        // end common block
        block_checkbox: {
            operator_limit_check: null,
            number_limit_check: ''
        },
        block_div_2: {
            label_q: '',
            label_a: ''
        },
        is_address_email_type_i: false,
        block_input: {
            minimum_number: '',
            maximum_number: '',
            from_range: '',
            to_range: '',
            number_after_decimal_point: '',
            auto_complete: 1,
            number_of_digits: 15,
            number_of_decimal_places: 5,
            duplicate_input: 2,
            confirm_input_twice: 2,
            is_bank_code: false,
            is_store_number: false,
            is_account_number: false,
            age_condition: {
                operator: null,
                value: ''
            }
        },
        block_text_area: {
            rows: '',
            cols: ''
        },
        block_date: {
            format_year: {
                type: 1,
                placeholder: '',
                type_calendar: 1,
                lower_limit: '',
                upper_limit: ''
            },
            format_month_day: {
                type: 1,
                placeholder_month: '',
                placeholder_day: ''
            },
            select_value_default: {
                year: null,
                month: null,
                day: null
            }
        },
        block_full_name: {
            placeholder_last_name: '',
            placeholder_first_name: ''
        },
        block_post_code: {
            feature_search_address: 2,
            placeholder_1: '',
            placeholder_2: '',
            prefecture_insertion: null,
            city_insertion: null,
            town_area_name_insertion: null
        },
        block_phone: {
            placeholder_1: '',
            placeholder_2: '',
            placeholder_3: ''
        },
        block_remaining_number: {
            remaining_number: 1,
            display_content: 1,
            remaining_text: '残り',
            text_after_remaining_number: '席',
            remaining_ratio: '',
            label_other: '(残りわずか)',
            color_text: '#D83636'
        },
        block_keyword_box: {
            matching_condition: [1, 2, 3],
            field_mask_display: 2,
            keyword_characters: '',
            duplicate_input: 2
        },
        block_parameter: {
            source_param: 1,
            param_name: '',
            error_redirect_url: '',
            is_duplicate: 2
        },
        block_upload_file: {
            maximum_file_size: '',
            allowed_extensions: ''
        }
    };
    if (!data) {
        obj = {
            ...obj
        };
    } else {
        obj = {
            ...obj,
            ...data,
            max_characters: data?.max_characters ?? '255'
        };
    }

    return obj;
};
const initFormPostCodeBlock = () => {
    const nextId = store.getters['managerForm/nextId'];
    const dataListBlockCreated = store.getters['managerForm/listBlockCreated'];
    const returnAddressPostCode = (type, countId) => {
        const count = dataListBlockCreated?.filter((item) => item.block_name === type || item.block_name.startsWith(type)).length;

        if (count === 0) {
            return {
                block_name: `${type}`,
                id: nextId + countId
            };
        } else {
            return {
                block_name: `${type}${count}`,
                id: nextId + countId
            };
        }
    };
    let obj = [
        {
            block_name: '郵便番号',
            block_type: ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE,
            order_required: true,
            label: '郵便番号',
            input_field_size: '',
            text_area_more_option: '',
            confirmation_page_display: 1,
            personal_information_setting: true,
            placeholder: '',
            max_characters: '255',
            number_of_items_displayed_per_line: 1,
            choice_placement_specification_question: 'default',
            choice_placement_specification_answer: 'default',
            layout: 'default',
            if_conditions_do_not_match: '',
            default_choice: null,
            default_choices: [],
            value_default_text: '',
            unselected_label: '',
            input_format: null,
            cell_background_color: {
                bg_question: '',
                bg_answer: '',
                is_bg_question_default: true,
                is_bg_answer_default: true
            },
            additional_setting: {
                note_left_block: '',
                note_right_block: '',
                note_bottom_block: '',
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE)
            },
            setting_others: {
                other_use: false,
                label_other: 'その他',
                value_other_required: false,
                width_other: '', //100
                uncheck_use: false,
                label_uncheck: 'チェックを外す'
            },
            option_value: [],
            option_unselected_label: {
                option_index: 0,
                unique_key: null,
                value: '',
                number_of_receptions: null
            },
            // end common block
            block_checkbox: {
                operator_limit_check: null,
                number_limit_check: ''
            },
            block_div_2: {
                label_q: '',
                label_a: ''
            },
            block_input: {
                minimum_number: '',
                maximum_number: '',
                from_range: '',
                to_range: '',
                number_after_decimal_point: '',
                auto_complete: 1,
                number_of_digits: 15,
                number_of_decimal_places: 5,
                duplicate_input: 2,
                confirm_input_twice: 2
            },
            block_text_area: {
                rows: '',
                cols: ''
            },
            block_date: {
                format_year: {
                    type: 1,
                    placeholder: '',
                    type_calendar: 1,
                    lower_limit: '',
                    upper_limit: ''
                },
                format_month_day: {
                    type: 1,
                    placeholder_month: '',
                    placeholder_day: ''
                },
                select_value_default: {
                    year: null,
                    month: null,
                    day: null
                }
            },
            block_full_name: {
                placeholder_last_name: '',
                placeholder_first_name: ''
            },
            block_post_code: {
                feature_search_address: 1,
                placeholder_1: '',
                placeholder_2: '',
                prefecture_insertion: returnAddressPostCode('都道府県', 1),
                city_insertion: returnAddressPostCode('市区町村', 2),
                town_area_name_insertion: returnAddressPostCode('町名番地', 3)
            },
            block_phone: {
                placeholder_1: '',
                placeholder_2: '',
                placeholder_3: ''
            },
            block_remaining_number: {
                remaining_number: 1,
                display_content: 1,
                remaining_text: '残り',
                text_after_remaining_number: '席',
                remaining_ratio: '',
                label_other: '(残りわずか)',
                color_text: '#D83636'
            },
            block_keyword_box: {
                matching_condition: [1, 2, 3],
                field_mask_display: 2,
                keyword_characters: '',
                duplicate_input: 2
            },
            block_parameter: {
                source_param: 1,
                param_name: '',
                error_redirect_url: '',
                is_duplicate: 2
            },
            block_upload_file: {
                maximum_file_size: '',
                allowed_extensions: ''
            }
        },
        {
            block_name: '都道府県',
            block_type: ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE,
            order_required: true,
            label: '都道府県',
            input_field_size: '',
            text_area_more_option: '',
            confirmation_page_display: 1,
            personal_information_setting: true,
            placeholder: '',
            max_characters: '255',
            number_of_items_displayed_per_line: 1,
            choice_placement_specification_question: 'default',
            choice_placement_specification_answer: 'default',
            layout: 'default',
            if_conditions_do_not_match: '',
            default_choice: {
                option_index: 0,
                unique_key: null,
                value: '',
                number_of_receptions: null
            },
            default_choices: [],
            value_default_text: '',
            unselected_label: '',
            input_format: null,
            cell_background_color: {
                bg_question: '',
                bg_answer: '',
                is_bg_question_default: true,
                is_bg_answer_default: true
            },
            additional_setting: {
                note_left_block: '',
                note_right_block: '<span style="font-size: 10pt; color: #2196f3;"> (例：東京都) </span>',
                note_bottom_block: '',
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE)
            },
            setting_others: {
                other_use: false,
                label_other: 'その他',
                value_other_required: false,
                width_other: '', //100
                uncheck_use: false,
                label_uncheck: 'チェックを外す'
            },
            option_value: LIST_PROVINCE_BLOCK(),
            option_unselected_label: {
                option_index: 0,
                unique_key: null,
                value: '',
                number_of_receptions: null
            },
            // end common block
            block_checkbox: {
                operator_limit_check: null,
                number_limit_check: ''
            },
            block_div_2: {
                label_q: '',
                label_a: ''
            },
            block_input: {
                minimum_number: '',
                maximum_number: '',
                from_range: '',
                to_range: '',
                number_after_decimal_point: '',
                auto_complete: 1,
                number_of_digits: 15,
                number_of_decimal_places: 5,
                duplicate_input: 2,
                confirm_input_twice: 2
            },
            block_text_area: {
                rows: '',
                cols: ''
            },
            block_date: {
                format_year: {
                    type: 1,
                    placeholder: '',
                    type_calendar: 1,
                    lower_limit: '',
                    upper_limit: ''
                },
                format_month_day: {
                    type: 1,
                    placeholder_month: '',
                    placeholder_day: ''
                },
                select_value_default: {
                    year: null,
                    month: null,
                    day: null
                }
            },
            block_full_name: {
                placeholder_last_name: '',
                placeholder_first_name: ''
            },
            block_post_code: {
                feature_search_address: 2,
                placeholder_1: '',
                placeholder_2: '',
                prefecture_insertion: null,
                city_insertion: null,
                town_area_name_insertion: null
            },
            block_phone: {
                placeholder_1: '',
                placeholder_2: '',
                placeholder_3: ''
            },
            block_remaining_number: {
                remaining_number: 1,
                display_content: 1,
                remaining_text: '残り',
                text_after_remaining_number: '席',
                remaining_ratio: '',
                label_other: '(残りわずか)',
                color_text: '#D83636'
            },
            block_keyword_box: {
                matching_condition: [1, 2, 3],
                field_mask_display: 2,
                keyword_characters: '',
                duplicate_input: 2
            },
            block_parameter: {
                source_param: 1,
                param_name: '',
                error_redirect_url: '',
                is_duplicate: 2
            },
            block_upload_file: {
                maximum_file_size: '',
                allowed_extensions: ''
            }
        },
        {
            block_name: '市区町村',
            block_type: ALL_BLOCK_TYPE.BLOCK_INPUT,
            order_required: true,
            label: '市区町村',
            input_field_size: '50',
            text_area_more_option: '',
            confirmation_page_display: 1,
            personal_information_setting: true,
            placeholder: '',
            max_characters: '255',
            number_of_items_displayed_per_line: 1,
            choice_placement_specification_question: 'default',
            choice_placement_specification_answer: 'default',
            layout: 'default',
            if_conditions_do_not_match: '',
            default_choice: null,
            default_choices: [],
            value_default_text: '',
            unselected_label: '',
            input_format: null,
            cell_background_color: {
                bg_question: '',
                bg_answer: '',
                is_bg_question_default: true,
                is_bg_answer_default: true
            },
            additional_setting: {
                note_left_block: '',
                note_right_block: '<span style="font-size: 10pt; color: #2196f3">(例：港区)</span>',
                note_bottom_block: '',
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_INPUT)
            },
            setting_others: {
                other_use: false,
                label_other: 'その他',
                value_other_required: false,
                width_other: '', //100
                uncheck_use: false,
                label_uncheck: 'チェックを外す'
            },
            option_value: [],
            option_unselected_label: {
                option_index: 0,
                unique_key: null,
                value: '',
                number_of_receptions: null
            },
            // end common block
            block_checkbox: {
                operator_limit_check: null,
                number_limit_check: ''
            },
            block_div_2: {
                label_q: '',
                label_a: ''
            },
            block_input: {
                minimum_number: '',
                maximum_number: '',
                from_range: '',
                to_range: '',
                number_after_decimal_point: '',
                auto_complete: 1,
                number_of_digits: 15,
                number_of_decimal_places: 5,
                duplicate_input: 2,
                confirm_input_twice: 2
            },
            block_text_area: {
                rows: '',
                cols: ''
            },
            block_date: {
                format_year: {
                    type: 1,
                    placeholder: '',
                    type_calendar: 1,
                    lower_limit: '',
                    upper_limit: ''
                },
                format_month_day: {
                    type: 1,
                    placeholder_month: '',
                    placeholder_day: ''
                },
                select_value_default: {
                    year: null,
                    month: null,
                    day: null
                }
            },
            block_full_name: {
                placeholder_last_name: '',
                placeholder_first_name: ''
            },
            block_post_code: {
                feature_search_address: 2,
                placeholder_1: '',
                placeholder_2: '',
                prefecture_insertion: null,
                city_insertion: null,
                town_area_name_insertion: null
            },
            block_phone: {
                placeholder_1: '',
                placeholder_2: '',
                placeholder_3: ''
            },
            block_remaining_number: {
                remaining_number: 1,
                display_content: 1,
                remaining_text: '残り',
                text_after_remaining_number: '席',
                remaining_ratio: '',
                label_other: '(残りわずか)',
                color_text: '#D83636'
            },
            block_keyword_box: {
                matching_condition: [1, 2, 3],
                field_mask_display: 2,
                keyword_characters: '',
                duplicate_input: 2
            },
            block_parameter: {
                source_param: 1,
                param_name: '',
                error_redirect_url: '',
                is_duplicate: 2
            },
            block_upload_file: {
                maximum_file_size: '',
                allowed_extensions: ''
            }
        },
        {
            block_name: '町名番地',
            block_type: ALL_BLOCK_TYPE.BLOCK_INPUT,
            order_required: true,
            label: '町名番地',
            input_field_size: '50',
            text_area_more_option: '',
            confirmation_page_display: 1,
            personal_information_setting: true,
            placeholder: '',
            max_characters: '255',
            number_of_items_displayed_per_line: 1,
            choice_placement_specification_question: 'default',
            choice_placement_specification_answer: 'default',
            layout: 'default',
            if_conditions_do_not_match: '',
            default_choice: null,
            default_choices: [],
            value_default_text: '',
            unselected_label: '',
            input_format: null,
            cell_background_color: {
                bg_question: '',
                bg_answer: '',
                is_bg_question_default: true,
                is_bg_answer_default: true
            },
            additional_setting: {
                note_left_block: '',
                note_right_block: '<span style="font-size: 10pt; color: #2196f3;">(例：赤坂0-0-0)</span>',
                note_bottom_block: '',
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_INPUT)
            },
            setting_others: {
                other_use: false,
                label_other: 'その他',
                value_other_required: false,
                width_other: '', //100
                uncheck_use: false,
                label_uncheck: 'チェックを外す'
            },
            option_value: [],
            option_unselected_label: {
                option_index: 0,
                unique_key: null,
                value: '',
                number_of_receptions: null
            },
            // end common block
            block_checkbox: {
                operator_limit_check: null,
                number_limit_check: ''
            },
            block_div_2: {
                label_q: '',
                label_a: ''
            },
            block_input: {
                minimum_number: '',
                maximum_number: '',
                from_range: '',
                to_range: '',
                number_after_decimal_point: '',
                auto_complete: 1,
                number_of_digits: 15,
                number_of_decimal_places: 5,
                duplicate_input: 2,
                confirm_input_twice: 2
            },
            block_text_area: {
                rows: '',
                cols: ''
            },
            block_date: {
                format_year: {
                    type: 1,
                    placeholder: '',
                    type_calendar: 1,
                    lower_limit: '',
                    upper_limit: ''
                },
                format_month_day: {
                    type: 1,
                    placeholder_month: '',
                    placeholder_day: ''
                },
                select_value_default: {
                    year: null,
                    month: null,
                    day: null
                }
            },
            block_full_name: {
                placeholder_last_name: '',
                placeholder_first_name: ''
            },
            block_post_code: {
                feature_search_address: 2,
                placeholder_1: '',
                placeholder_2: '',
                prefecture_insertion: null,
                city_insertion: null,
                town_area_name_insertion: null
            },
            block_phone: {
                placeholder_1: '',
                placeholder_2: '',
                placeholder_3: ''
            },
            block_remaining_number: {
                remaining_number: 1,
                display_content: 1,
                remaining_text: '残り',
                text_after_remaining_number: '席',
                remaining_ratio: '',
                label_other: '(残りわずか)',
                color_text: '#D83636'
            },
            block_keyword_box: {
                matching_condition: [1, 2, 3],
                field_mask_display: 2,
                keyword_characters: '',
                duplicate_input: 2
            },
            block_parameter: {
                source_param: 1,
                param_name: '',
                error_redirect_url: '',
                is_duplicate: 2
            },
            block_upload_file: {
                maximum_file_size: '',
                allowed_extensions: ''
            }
        },
        {
            block_name: 'アパート・マンション名／部屋番号',
            block_type: ALL_BLOCK_TYPE.BLOCK_INPUT,
            order_required: false,
            label: 'アパート・マンション名／部屋番号',
            input_field_size: '50',
            text_area_more_option: '',
            confirmation_page_display: 1,
            personal_information_setting: true,
            placeholder: '',
            max_characters: '255',
            number_of_items_displayed_per_line: 1,
            choice_placement_specification_question: 'default',
            choice_placement_specification_answer: 'default',
            layout: 'default',
            if_conditions_do_not_match: '',
            default_choice: null,
            default_choices: [],
            value_default_text: '',
            unselected_label: '',
            input_format: null,
            cell_background_color: {
                bg_question: '',
                bg_answer: '',
                is_bg_question_default: true,
                is_bg_answer_default: true
            },
            additional_setting: {
                note_left_block: '',
                note_right_block: '',
                note_bottom_block: '',
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_INPUT)
            },
            setting_others: {
                other_use: false,
                label_other: 'その他',
                value_other_required: false,
                width_other: '', //100
                uncheck_use: false,
                label_uncheck: 'チェックを外す'
            },
            option_value: [],
            option_unselected_label: {
                option_index: 0,
                unique_key: null,
                value: '',
                number_of_receptions: null
            },
            // end common block
            block_checkbox: {
                operator_limit_check: null,
                number_limit_check: ''
            },
            block_div_2: {
                label_q: '',
                label_a: ''
            },
            block_input: {
                minimum_number: '',
                maximum_number: '',
                from_range: '',
                to_range: '',
                number_after_decimal_point: '',
                auto_complete: 1,
                number_of_digits: 15,
                number_of_decimal_places: 5,
                duplicate_input: 2,
                confirm_input_twice: 2
            },
            block_text_area: {
                rows: '',
                cols: ''
            },
            block_date: {
                format_year: {
                    type: 1,
                    placeholder: '',
                    type_calendar: 1,
                    lower_limit: '',
                    upper_limit: ''
                },
                format_month_day: {
                    type: 1,
                    placeholder_month: '',
                    placeholder_day: ''
                },
                select_value_default: {
                    year: null,
                    month: null,
                    day: null
                }
            },
            block_full_name: {
                placeholder_last_name: '',
                placeholder_first_name: ''
            },
            block_post_code: {
                feature_search_address: 2,
                placeholder_1: '',
                placeholder_2: '',
                prefecture_insertion: null,
                city_insertion: null,
                town_area_name_insertion: null
            },
            block_phone: {
                placeholder_1: '',
                placeholder_2: '',
                placeholder_3: ''
            },
            block_remaining_number: {
                remaining_number: 1,
                display_content: 1,
                remaining_text: '残り',
                text_after_remaining_number: '席',
                remaining_ratio: '',
                label_other: '(残りわずか)',
                color_text: '#D83636'
            },
            block_keyword_box: {
                matching_condition: [1, 2, 3],
                field_mask_display: 2,
                keyword_characters: '',
                duplicate_input: 2
            },
            block_parameter: {
                source_param: 1,
                param_name: '',
                error_redirect_url: '',
                is_duplicate: 2
            },
            block_upload_file: {
                maximum_file_size: '',
                allowed_extensions: ''
            }
        }
    ];

    return obj;
};

const initDepositBlock = () => {
    const getObjInput = initFormBlock().block_input;
    const groupDeposit = [
        {
            block_name: '【振込み口座情報】',
            block_type: ALL_BLOCK_TYPE.BLOCK_DISPLAY_2,
            block_div_2: {
                label_q: '<strong>【振込み口座情報】</strong>',
                label_a:
                    '<span style="color: #f44336;"><strong>初回応募時に口座情報に不備のあった方は必ずご入力ください。</strong></span><br /><br /><span style="color: #f44336;"><strong>【注意事項】</strong></span><br /><span style="color: #f44336;">■応募者ご本人様名義の口座のみ有効となります。</span><br /><span style="color: #f44336;">※法人名義の口座は無効となりますのでご注意ください。</span><br /><span style="color: #f44336;">■日本国内の金融機関(口座)のみご利用いただけます。</span><br /><span style="color: #f44336;">　海外の金融機関(口座)はご利用いただけませんのでご注意ください。</span><br /><span style="color: #f44336;">■支店番号は銀行ごとの統合や支店番号変更等がある場合がございますので、</span><br /><span style="color: #f44336;">各銀行のHP等で、最新の支店番号をご確認いただき、ご入力ください。</span><br /><br /><span style="color: #f44336;"><strong>【ゆうちょ銀行の口座情報でご登録いただく方へ】</strong></span><br /><span style="color: #f44336;">ゆうちょ銀行口座の振込用「店名」「店番号(3桁)」「口座番号(7桁)」が必要となります。</span><br /><span style="color: #f44336;">記号(5桁)・番号(8桁)の口座情報しかわからない場合、<br />ゆうちょ銀行のホームページで「店名・店番号・口座番号」をお調べください。<br /></span>'
            },
            cell_background_color: {
                bg_question: '',
                bg_answer: '',
                is_bg_question_default: true,
                is_bg_answer_default: true
            },
            layout: 'cols'
        },
        {
            block_name: '振込銀行名',
            block_type: ALL_BLOCK_TYPE.BLOCK_INPUT,
            label: '振込銀行名',
            input_format: OPTION_INPUT_FORMAT[0],
            order_required: true,
            additional_setting: {
                note_left_block: '',
                note_right_block: '',
                note_bottom_block: '',
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_INPUT)
            }
        },
        {
            block_name: '銀行コード',
            block_type: ALL_BLOCK_TYPE.BLOCK_INPUT,
            label: '銀行コード',
            input_format: OPTION_INPUT_FORMAT[8],
            block_input: { ...getObjInput, is_bank_code: true },
            max_characters: 4,
            order_required: true,
            additional_setting: {
                note_left_block: '',
                note_right_block: '',
                note_bottom_block: `<span style="font-size: 10pt; color: #2196f3">※半角数字4桁</span>`,
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_INPUT)
            }
        },
        {
            block_name: '銀行支店名',
            block_type: ALL_BLOCK_TYPE.BLOCK_INPUT,
            label: '銀行支店名',
            input_format: OPTION_INPUT_FORMAT[0],
            order_required: true,
            additional_setting: {
                note_left_block: '',
                note_right_block: '',
                note_bottom_block: '',
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_INPUT)
            }
        },
        {
            block_name: '店番号',
            block_type: ALL_BLOCK_TYPE.BLOCK_INPUT,
            label: '店番号',
            input_format: OPTION_INPUT_FORMAT[8],
            block_input: { ...getObjInput, is_store_number: true },
            max_characters: 3,
            order_required: true,
            additional_setting: {
                note_left_block: '',
                note_right_block: '',
                note_bottom_block: `<span style="font-size: 10pt; color: #2196f3">※半角数字3桁</span>`,
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_INPUT)
            }
        },
        {
            block_name: '口座種別',
            block_type: ALL_BLOCK_TYPE.BLOCK_RADIO,
            label: '口座種別',
            order_required: true,
            option_value: [
                {
                    option_index: 0,
                    unique_key: 1,
                    value: '普通',
                    number_of_receptions: ''
                },
                {
                    option_index: 1,
                    unique_key: 2,
                    value: '当座',
                    number_of_receptions: ''
                }
            ],
            additional_setting: {
                note_left_block: '',
                note_right_block: '',
                note_bottom_block: '',
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_RADIO)
            }
        },
        {
            block_name: '口座番号',
            block_type: ALL_BLOCK_TYPE.BLOCK_INPUT,
            label: '口座番号',
            input_format: OPTION_INPUT_FORMAT[8],
            block_input: { ...getObjInput, is_account_number: true },
            max_characters: 7,
            order_required: true,
            additional_setting: {
                note_left_block: '',
                note_right_block: '',
                note_bottom_block:
                    '<span style="font-size: 10pt; color: #2196f3">※半角数字7桁</span><br/><span style="font-size: 10pt;color: #f44336">※6桁の場合は頭に「0」をつけてください</span><br/><span style="font-size: 10pt;color: #f44336">※8桁の場合は最後の「1」は入力不要です</span>',
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_INPUT)
            }
        },
        {
            block_name: '口座名義',
            block_type: ALL_BLOCK_TYPE.BLOCK_INPUT,
            label: '口座名義',
            input_format: OPTION_INPUT_FORMAT[6],
            block_input: { ...getObjInput },
            order_required: true,
            additional_setting: {
                note_left_block: '',
                note_right_block: '',
                note_bottom_block: `
                   <span style="font-size: 10pt;color: #f44336">※姓名の間にスペースは入れずにご入力ください</span>
                    <br />
                    <span style="font-size: 10pt;color: #f44336">
                        ※応募者様のご本人名義(フルネーム)でご入力ください
                    </span>
                    <br />
                    <span style="font-size: 10pt;color: #f44336">
                        ご本人名義以外はキャッシュバック対象外となりますので、ご注意ください。
                    </span>`,
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_INPUT)
            }
        }
    ];
    return groupDeposit.map((item) => initFormBlock(item));
};
const initAddressEmailTypeIBlock = () => {
    const groupBlock = [
        {
            block_name: i18n.t('managerForm.settingPage.pageTypeI.registeredEmailAddress'),
            block_type: ALL_BLOCK_TYPE.BLOCK_DISPLAY_2,
            block_div_2: {
                label_q: i18n.t('managerForm.settingPage.pageTypeI.registeredEmailAddress'),
                label_a: 'example@paldia.co.jp'
            },
            is_address_email_type_i: true
        }
    ];
    return groupBlock.map((item) => initFormBlock(item));
};
const initInfoFullNameBlock = () => {
    const groupBlock = [
        {
            block_name: '氏名',
            block_type: ALL_BLOCK_TYPE.BLOCK_FULL_NAME,
            label: '氏名',
            input_format: OPTION_INPUT_FORMAT_FULL_NAME[0],
            order_required: true,
            max_characters: 100,
            personal_information_setting: true,
            additional_setting: {
                note_left_block: '',
                note_right_block: '',
                note_bottom_block: '',
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_FULL_NAME)
            }
        },
        {
            block_name: 'フリガナ',
            block_type: ALL_BLOCK_TYPE.BLOCK_FULL_NAME,
            label: 'フリガナ',
            input_format: OPTION_INPUT_FORMAT_FULL_NAME[2],
            order_required: true,
            max_characters: 100,
            personal_information_setting: true,
            additional_setting: {
                note_left_block: '',
                note_right_block: '',
                note_bottom_block: '',
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_FULL_NAME)
            }
        }
    ];
    return groupBlock.map((item) => initFormBlock(item));
};
const initEmailAddressBlock = () => {
    const groupBlock = [
        {
            block_name: 'メールアドレス',
            block_type: ALL_BLOCK_TYPE.BLOCK_INPUT,
            label: 'メールアドレス',
            input_format: OPTION_INPUT_FORMAT[1],
            order_required: true,
            additional_setting: {
                note_left_block: '',
                note_right_block: '',
                note_bottom_block: '',
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_INPUT)
            }
        }
    ];
    return groupBlock.map((item) => initFormBlock(item));
};
const initFormPhoneNumberBlock = () => {
    const groupBlock = [
        {
            block_name: '電話番号',
            block_type: ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER,
            label: '電話番号',
            input_format: OPTION_INPUT_FORMAT[1],
            order_required: true,
            additional_setting: {
                note_left_block: '',
                note_right_block: '',
                note_bottom_block: '',
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER)
            }
        }
    ];
    return groupBlock.map((item) => initFormBlock(item));
};

const initEmailAddressConfirmBlock = () => {
    const groupBlock = [
        {
            block_name: 'メールアドレス',
            block_type: ALL_BLOCK_TYPE.BLOCK_INPUT,
            label: 'メールアドレス',
            input_format: OPTION_INPUT_FORMAT[1],
            order_required: true,
            additional_setting: {
                note_left_block: '',
                note_right_block: '',
                note_bottom_block: '',
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_INPUT)
            },
            block_input: {
                minimum_number: '',
                maximum_number: '',
                from_range: '',
                to_range: '',
                number_after_decimal_point: '',
                auto_complete: 1,
                number_of_digits: 15,
                number_of_decimal_places: 5,
                duplicate_input: 2,
                confirm_input_twice: 1,
                is_bank_code: false
            }
        }
    ];
    return groupBlock.map((item) => initFormBlock(item));
};

const initAgeAndGenderBlock = () => {
    const groupBlock = [
        {
            block_name: '年齢',
            block_type: ALL_BLOCK_TYPE.BLOCK_SELECT,
            label: '年齢',
            input_format: OPTION_INPUT_FORMAT[2],
            order_required: true,
            additional_setting: {
                note_left_block: '',
                note_right_block: '',
                note_bottom_block: '',
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_SELECT)
            },
            option_value: [
                {
                    option_index: 0,
                    unique_key: 1,
                    value: '～10代',
                    number_of_receptions: ''
                },
                {
                    option_index: 1,
                    unique_key: 2,
                    value: '20代',
                    number_of_receptions: ''
                },
                {
                    option_index: 2,
                    unique_key: 3,
                    value: '30代',
                    number_of_receptions: ''
                },
                {
                    option_index: 3,
                    unique_key: 4,
                    value: '40代',
                    number_of_receptions: ''
                },
                {
                    option_index: 4,
                    unique_key: 5,
                    value: '50代',
                    number_of_receptions: ''
                },
                {
                    option_index: 5,
                    unique_key: 6,
                    value: '60代',
                    number_of_receptions: ''
                },
                {
                    option_index: 6,
                    unique_key: 7,
                    value: '70代',
                    number_of_receptions: ''
                },
                {
                    option_index: 7,
                    unique_key: 8,
                    value: '80代～',
                    number_of_receptions: ''
                }
            ]
        },
        {
            block_name: '性別',
            block_type: ALL_BLOCK_TYPE.BLOCK_RADIO,
            label: '性別',
            order_required: true,
            additional_setting: {
                note_left_block: '',
                note_right_block: '',
                note_bottom_block: '',
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_RADIO)
            },
            option_value: [
                {
                    option_index: 0,
                    unique_key: 1,
                    value: '男性',
                    number_of_receptions: ''
                },
                {
                    option_index: 1,
                    unique_key: 2,
                    value: '女性',
                    number_of_receptions: ''
                },
                {
                    option_index: 2,
                    unique_key: 3,
                    value: '回答しない',
                    number_of_receptions: ''
                }
            ]
        }
    ];
    return groupBlock.map((item) => initFormBlock(item));
};
const initGenderBlock = () => {
    const groupBlock = [
        {
            block_name: '性別',
            block_type: ALL_BLOCK_TYPE.BLOCK_RADIO,
            label: '性別',
            order_required: true,
            additional_setting: {
                note_left_block: '',
                note_right_block: '',
                note_bottom_block: '',
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_RADIO)
            },
            option_value: [
                {
                    option_index: 0,
                    unique_key: 1,
                    value: '男性',
                    number_of_receptions: ''
                },
                {
                    option_index: 1,
                    unique_key: 2,
                    value: '女性',
                    number_of_receptions: ''
                },
                {
                    option_index: 2,
                    unique_key: 3,
                    value: '回答しない',
                    number_of_receptions: ''
                }
            ]
        }
    ];
    return groupBlock.map((item) => initFormBlock(item));
};
const initAgeBlock = () => {
    const getObjInput = initFormBlock().block_input;
    const groupBlock = [
        {
            block_name: '年齢',
            block_type: ALL_BLOCK_TYPE.BLOCK_INPUT,
            label: '年齢',
            input_format: OPTION_INPUT_FORMAT[2],
            order_required: true,
            block_input: {
                ...getObjInput,
                age_condition: {
                    operator: OPTION_AGE_CONDITION.find((item) => item.value === '<') || { id: 2, value: '<' },
                    value: '17'
                }
            },
            additional_setting: {
                note_left_block: '',
                note_right_block: '',
                note_bottom_block: '',
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_INPUT)
            }
        }
    ];
    return groupBlock.map((item) => initFormBlock(item));
};
const initXAccountBlock = () => {
    const getObjKeyword = initFormBlock().block_keyword_box;
    const groupBlock = [
        {
            block_name: 'Xアカウント',
            block_type: ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX,
            label: 'Xアカウント',
            order_required: true,
            block_keyword_box: {
                ...getObjKeyword,
                keyword_characters: '000'
            },
            additional_setting: {
                note_left_block: `<span style="font-size: 10pt">@</span>`,
                note_right_block: '<span style="font-size: 10pt; color: #2196f3"> （例：abc1234567） </span>',
                note_bottom_block:
                    '<span class="mt-2" style="font-size: 10pt;color: #f44336">※当選のDMを受け取ったX ID（@以降）を半角英数字でご入力ください。<br />XIDに不備がある場合、登録が完了できません。</span>',
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX)
            }
        }
    ];
    return groupBlock.map((item) => initFormBlock(item));
};
const initInstagramAccountBlock = () => {
    const getObjKeyword = initFormBlock().block_keyword_box;
    const groupBlock = [
        {
            block_name: 'Instagramアカウント',
            block_type: ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX,
            label: 'Instagramアカウント',
            order_required: true,
            block_keyword_box: {
                ...getObjKeyword,
                keyword_characters: '000'
            },
            additional_setting: {
                note_left_block: `<span style="font-size: 10pt">@</span>`,
                note_right_block: '<span style="font-size: 10pt; color: #2196f3"> （例：abc1234567） </span>',
                note_bottom_block: `<span class="mt-2" style="font-size: 10pt;color: #f44336">※当選のDMを受け取ったInstagramID（@以下）を半角英数でご入力ください。<br />InstagramIDに不備がある場合、登録が完了できません。</span>`,
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX)
            }
        }
    ];
    return groupBlock.map((item) => initFormBlock(item));
};

const initSerialCodeInputBlock = () => {
    const groupBlock = [
        {
            block_name: 'シリアルコード入力画面',
            label: 'シリアルコード入力画面',
            block_type: ALL_BLOCK_TYPE.BLOCK_INPUT,
            order_required: true,
            max_characters: '255',
            status_record_block: 'create',
            is_required_block: true,
            is_serial_code_type_b: true,
            additional_setting: {
                note_left_block: '',
                note_right_block: '',
                note_bottom_block: '',
                error_message_block: getListMsgStore(ALL_BLOCK_TYPE.BLOCK_INPUT)
            }
        }
    ];
    return groupBlock.map((item) => initFormBlock(item));
};

export {
    configFormPage,
    initFormBlock,
    initFormPostCodeBlock,
    initInfoFullNameBlock,
    initFormPhoneNumberBlock,
    initEmailAddressBlock,
    initEmailAddressConfirmBlock,
    initAgeAndGenderBlock,
    initGenderBlock,
    initAgeBlock,
    initXAccountBlock,
    initInstagramAccountBlock,
    initAddressEmailTypeIBlock,
    configEditFormPage,
    configEditButtonPage_I,
    configEditButtonPage,
    configEditLabelPage,
    configFormDraw,
    configFormWinning,
    configFormRejection,
    initDepositBlock,
    initSerialCodeInputBlock,
    configModalAddPage,
    configModalEditPage,
    configModalPreviewForm,
    configModalSendMailed
};
